const BANK_INFORMATION_ADDED = "Your bank information added successfully"
const DOCUMENTS_SIGNED = "Your documents have been signed successfully."

export const signingSuccessText = (documentsSigned) => (documentsSigned ? DOCUMENTS_SIGNED : BANK_INFORMATION_ADDED)
